import { Component, AfterViewInit, ViewChild } from "@angular/core";
import { ROUTER_DIRECTIVES } from "@angular/router";
import { ClientDocument } from "../domain/clientDocument";
import { ClientDocumentService } from "../service/clientDocument.service";
import { ClientService } from "../service/client.service";
import { Observable } from "rxjs/Observable";
import { NavigationService } from '../service/navigation.service';
import { TabSelectedService } from '../service/tabSelected.service';
import { ChangeDetectorRef, OnInit } from '@angular/core';

import { LoginService } from '../service/login.service';
import { User } from '../domain/user';
import { Bank } from "../domain/bank";
import { BankService } from "../service/bank.service";

@Component( {
    selector: 'client-panel',
    template: require( './client.panel.component.html' ),
    directives: [ROUTER_DIRECTIVES]
} )
export class ClientPanel implements OnInit {

    private showInfractionDocuments: boolean;
    private showKmDocuments: boolean;
    private showProcedureDocuments: boolean;
    private showPatentDocuments: boolean;

    public clientInfractionDocuments: ClientDocument[];
    public clientKmDocuments: ClientDocument[];
    public clientProcedureDocuments: ClientDocument[];
    public clientPatentDocuments: ClientDocument[];

    public isPayReceiptActive: boolean;
    private infTab: any;
    private kmTab: any;
    private procTab: any;
    private patTab: any;

    private userLogged: User;
    private bankId: string;

    constructor( private navigationService: NavigationService,
        private clientDocumentService: ClientDocumentService,
        private clientService: ClientService, private tabSelectedService: TabSelectedService,
        private changeDetector: ChangeDetectorRef, private loginService: LoginService ) {
        this.init();
    }

    private init(): void {
        this.isPayReceiptActive = false;
        this.showProcedureDocuments = false;
        this.showInfractionDocuments = false;
        this.showKmDocuments = false;
        this.showPatentDocuments = false;
    }

    public ngOnInit() {

        this.userLogged = this.loginService.getUserLogged();
        this.getUser();  

    }

    private getUser(): void {

        if ( !this.userLogged ) {
            this.loginService.getUserLoggedSubject().subscribe(
                ( userLogged ) => {
                    this.userLogged = userLogged;
                    this.updateUserLogged();
                    this.getData();
                    this.showDocuments();
                },
                () => {
                    //Do Nothing.
                } );
        } else {
            this.updateUserLogged();
            this.getData();
            this.showDocuments();
        }
    }

    private updateUserLogged(): void {
        if ( this.userLogged.rol.client ) {
            this.bankId = this.userLogged.bank.id.toString();
        }
    }

    public showPayReceipt(): boolean{
        return (this.isPayReceiptActive && this.showInfractionDocuments);
    }

    public showRequestProcedure(): boolean{
        return this.showProcedureDocuments;
    }
    
    public ngAfterViewChecked() {
        this.showDocuments();
    }

    public showDocuments(): void {

        let tab = this.tabSelectedService.getActiveTab();

        if ( tab === 'kmHistory' )
            this.showKmDocs();
        if ( tab === 'infractions' )
            this.showInfractionDocs();
        if ( tab === 'procedures' )
            this.showProcedureDocs();
        if ( tab === 'patentPayment' )
            this.showPatentDocs();
    }

    public showInfractionDocs(): void {
        this.showInfractionDocuments = true;
        this.showProcedureDocuments = false;
        this.showKmDocuments = false;
        this.showPatentDocuments = false;
        this.changeDetector.detectChanges();
    }
    public showProcedureDocs(): void {
        this.showProcedureDocuments = true;
        this.showInfractionDocuments = false;
        this.showKmDocuments = false;
        this.showPatentDocuments = false;
        this.changeDetector.detectChanges();
    }
    public showKmDocs(): void {
        this.showKmDocuments = true;
        this.showProcedureDocuments = false;
        this.showInfractionDocuments = false;
        this.showPatentDocuments = false;
        this.changeDetector.detectChanges();
    }
    public showPatentDocs(): void {
        this.showPatentDocuments = true;
        this.showProcedureDocuments = false;
        this.showInfractionDocuments = false;
        this.showKmDocuments = false;
        this.changeDetector.detectChanges();
    }


    private getData(): void {

        let forkTasks: Observable<any>[] = [];
        forkTasks.push( this.clientDocumentService.getClientDocumentsByBank( this.bankId ) );
        forkTasks.push( this.clientService.isPayReceiptActive() );
        forkTasks.push( this.clientDocumentService.getClientKmDocumentsByBank( this.bankId ) );
        forkTasks.push( this.clientDocumentService.getClientProcedureDocumentsByBank( this.bankId ) );
        forkTasks.push( this.clientDocumentService.getClientPatentDocumentsByBank( this.bankId ) );
        Observable.forkJoin( forkTasks ).subscribe(
            this.setData.bind( this ),
            () => {
                //this.bindError('Ocurrió un error al cargar los datos del cliente.');
            } );
    }

    private setData( data: any[] ): void {

        this.clientInfractionDocuments = data[0];
        this.isPayReceiptActive = data[1];
        this.clientKmDocuments = data[2];
        this.clientProcedureDocuments = data[3];
        this.clientPatentDocuments = data[4];
        // Para filtrar en vista
        //        this.clientInfractionDocuments = this.filterByBank( this.clientInfractionDocuments );
        //        this.clientKmDocuments = this.filterByBank( this.clientKmDocuments );
        //        this.clientProcedureDocuments = this.filterByBank( this.clientProcedureDocuments );
        //        this.clientPatentDocuments = this.filterByBank( this.clientPatentDocuments );

    }

//    private filterByBank( data: ClientDocument[] ): ClientDocument[] {
//
//        let filteredDocs: ClientDocument[];
//        filteredDocs = data.filter( doc => doc.bankIds.some( id => id === this.bankId.toString() ) === true );
//
//        return filteredDocs;
//    }

    /*private bindError(messageError: string): void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }*/
}


/** WEBPACK FOOTER **
 ** ./src/app/client/client.panel.component.ts
 **/